'use strict'
/** @import ../types */
import * as React from 'react'

import '../../assets/css/style.css'
import '../../assets/css/vendor/animate.min.css'
import '../../assets/css/vendor/hamburgers.css'
import '../../assets/css/vendor/normalize.css'
import '../../assets/icon/style.css'
import '../../assets/js/adobe_fonts.js'
import '../../assets/js/tailwindcss.js'

import { ArrowRight } from '@mui/icons-material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import _get from 'lodash/get'
import { useModalExtra } from '../../_components/Modal.js'
import { SpinnerButton } from '../../pages/common/CustomButton.js'
import { noCategoryKey, rootNodeKey } from '../../pages/master/certificationInfo/extra/useCertificationInfo'
import CustomTooltip from '../../_components/CustomTooltip.js'
import { getMessage } from './MessageUtils.js'

/**
 * @param {CertificationSelectorProps} props
 * @returns
 */
const CertificationSelector = (props) => {
  const {
    defaultValue,
    editMode = false,
    singleMode = false,
    certifications = {},
    onSave,
    checkIfCertificationSetNameExists
  } = props

  const initialValues = React.useMemo(() => initialState(defaultValue), [defaultValue])

  const [_, _dispatch] = React.useReducer(certificationSelectorReducer, initialValues)
  const filterRef = React.useRef(null)

  const { _closeUpModal } = useModalExtra()

  const selectedIds = Array.from(_.certificationCodeList)
  const dispatch = (type, payload) => _dispatch({ type, payload })

  const { errors } = _

  const displayCertifications =
    Object.keys(_.filteredCertifications).length > 0 ? _.filteredCertifications : _.allCertifications
  // 検索一致の条件

  const displayCertificationKeys = Object.keys(displayCertifications)

  const showNoResults = displayCertificationKeys.length === 1 && displayCertificationKeys[0] === rootNodeKey

  const init = async () => {
    dispatch('init')
  }

  React.useEffect(() => {
    init()
  }, [defaultValue])

  /**
   * @function formHasErrors
   * @param {CertificationTree} _
   */
  const formHasErrors = (_) => {
    const errorState = {
      certificationSetName: [],
      certificationCodeList: []
    }

    if (singleMode) {
      const selectedValue = Array.from(_.certificationCodeList).pop()

      if (selectedValue === '' || selectedValue === undefined) {
        errorState.certificationCodeList.push(getMessage('E010014', '資格', '選択'))
      }

      if (checkIfCertificationSetNameExists?.(selectedValue)) {
        errorState.certificationCodeList.push('設定済みの資格です')
      }
    } else {
      if (_.certificationSetName.trim() === '') {
        errorState.certificationSetName.push(getMessage('E010001', '資格セット名'))
      }

      if (checkIfCertificationSetNameExists?.(_.certificationSetName)) {
        errorState.certificationSetName.push(getMessage('E010013', ' 同一の「資格セット名」'))
      }

      if (_.certificationCodeList.size === 0) {
        errorState.certificationCodeList.push(getMessage('E010014', '資格', '選択'))
      }
    }

    if (Object.values(errorState).some((e) => e.length > 0)) return errorState

    return false
  }

  function initialState(defaultValue) {
    let certificationCodeList = new Set()

    if (defaultValue?.certificationCodeList) {
      certificationCodeList = new Set(defaultValue.certificationCodeList.filter(Boolean))
    }

    const init = {
      certificationSetName: defaultValue?.certificationSetName || '',
      certificationCodeList,
      filteredCertifications: {},
      allCertifications: certifications,
      errors: { certificationCodeList: [], certificationSetName: [] }
    }

    return init
  }

  function certificationSelectorReducer(state, action) {
    let tempState = { ...state }

    switch (action.type) {
      case 'init':
        tempState = initialState(defaultValue)

        break
      case 'change_name':
        const value = action.payload
        return {
          ...state,
          certificationSetName: value
        }
      case 'remove_certification':
        if (singleMode) {
          tempState.certificationCodeList = new Set()
          return tempState
        }
        tempState.certificationCodeList.delete(action.payload)
        break
      case 'filter_certification':
        filterCertifications(tempState, action.payload)
        break

      case 'select_certification':
        // action.payload: certificationid
        tempState.certificationCodeList.add(action.payload)

        tempState.errors.certificationCodeList = []
        break
      case 'select_certification_single':
        tempState.certificationCodeList = new Set([action.payload])
        tempState.errors.certificationCodeList = []

        break
      case 'save':
        // if (singleMode) {
        //   tempState.name = Array.from(tempState.certificationCodeList)[0]
        // }
        // tempState.certificationCodeList = Array.from(tempState.certificationCodeList)
        break
      case 'cancel':
        onCancel?.()
        break
      case 'error':
        tempState.errors = action.payload
        break
      default:
        return state
    }

    return tempState
  }

  // 資格の検索
  function filterCertifications(tempState, payload) {
    const all = Object.entries(tempState.allCertifications)
    const allMap = tempState.allCertifications

    if (all.length === 0) {
      tempState.filterCertifications = {}
      return
    }

    const filteredParent = []
    const filteredChild = []

    const filteredNodes = all.filter(([_, value]) => {
      const nodeData = value.CertificationData
      const nodeName = (value.Metadata.Depth === 3 ? nodeData.Name : nodeData.CategoryName) || ''

      return nodeName.toLowerCase().includes(payload.toLowerCase())
    })

    for (const node of filteredNodes) {
      // 親のフィルタ
      const parentNodeId = _get(allMap, `${node[0]}.Metadata.SuperNode`, null)
      let parentNode = _get(allMap, `${parentNodeId}`, null)

      while (parentNode !== null) {
        filteredParent.push([parentNode.node, parentNode])
        parentNode = allMap[parentNode.Metadata.SuperNode] || null
      }

      // 子のフィルタ
      const childNodes = _get(allMap, `${node[0]}.SubNode`, [])
      const queue = [...childNodes]

      while (queue.length > 0) {
        const node = queue.shift()
        filteredChild.push([node, _get(allMap, node)])

        const nodeChildren = _get(allMap, `${node}.SubNode`, [])
        if (nodeChildren.length > 0) {
          queue.push(...nodeChildren)
        }
      }
    }

    tempState.filteredCertifications = Object.fromEntries([
      ...filteredParent,
      ...filteredNodes,
      ...filteredChild,
      [rootNodeKey, tempState.allCertifications[rootNodeKey]]
    ])
  }

  /** @function handleSave 設定処理 */
  const handleSave = () => {
    const errorState = formHasErrors(_)

    if (errorState) {
      dispatch('error', errorState)
      return
    }

    onSave({
      certificationSetName: String(_?.certificationSetName || '').trim(),
      certificationCodeList: Array.from(_.certificationCodeList)
    })

    setTimeout(() => {
      dispatch('init')
    }, 500)
  }

  const isSubmitDisabled = _.certificationCodeList.size === 0

  React.useLayoutEffect(() => {
    /** @type {HTMLDivElement} modalWindow */
    const modalWindow = document.querySelector('.modal-window')
    const modalWindowContent = document.querySelector('.modal-window__content')
    const modalFooter = document.querySelector(
      '#modal-context-modal-window--upload-confirm > div.modal-window__content.px-8.py-5 > div.modal-content-footer.mt-8'
    )

    const modalWindowClassList = [
      'w-[700px]',
      singleMode ? 'h-[650px]' : 'h-[700px]',
      '2xl:h-[750px]',
      'max-h-[97dvh]',
      'overflow-y-auto'
    ]
    const modalWindowContentClassList = ['max-h-[400px]']
    const modalFooterClassList = ['!m-0']

    modalWindow && modalWindow.classList.add(...modalWindowClassList)
    modalWindowContent && modalWindowContent.classList.add(...modalWindowContentClassList)
    modalFooter && modalFooter?.classList.add(...modalFooterClassList)

    return () => {
      modalWindow.classList.remove(...modalWindowClassList)
      modalWindowContent.classList.remove(...modalWindowContentClassList)
      modalFooter?.classList.remove(...modalFooterClassList)
    }
  }, [])

  const SelectedCertifications = (props) => {
    const { name, selectedId } = props
    return (
      <div
        className={`inline-flex ${
          singleMode && 'w-full'
        }  bg-blue-200 text-blue-900 font-medium items-center px-2 py-1 justify-between rounded `}
      >
        <CustomTooltip title={name}>
          {(ref) => (
            <p ref={ref} className="!text-xs  truncate font-bold   max-w-[22rem] inline-block">
              {name}
            </p>
          )}
        </CustomTooltip>
        <button
          data-testid="remove"
          type=""
          className="text-base ml-3 "
          onClick={() => dispatch('remove_certification', selectedId)}
        >
          ×
        </button>{' '}
      </div>
    )
  }

  const handleCancel = () => {
    _closeUpModal()
    dispatch('init')
    if (filterRef.current) filterRef.current.value = ''
  }

  const onlyCategoryNone =
    displayCertificationKeys.length === 2 &&
    displayCertificationKeys.includes(noCategoryKey) &&
    displayCertifications[noCategoryKey].SubNode.length === 0

  return (
    <div className="   text-sm">
      <div className="max-h-[50%] ">
        <table className="form-table form-control w-full table-fixed">
          <tbody className="text-caption-2">
            {!singleMode && (
              <tr>
                <th className="form-table__col-head w-[150px]">
                  <label htmlFor="certificationSetName" className="text-h7 font-bold">
                    資格セット名<span className="red--text">*</span>
                  </label>
                </th>
                <td className="form-table__col-data">
                  <input
                    id="certificationSetName"
                    placeholder="資格セット名を入力してください"
                    type="text"
                    className="block rounded-lg px-3 py-1 w-full "
                    value={_.certificationSetName}
                    onChange={(e) => dispatch('change_name', e.target.value)}
                  />
                  {errors?.certificationSetName?.map((e, index) => (
                    <span key={index} className="red--text">
                      {e}
                    </span>
                  ))}
                </td>
              </tr>
            )}
            <tr>
              <th className="form-table__col-head w-[150px] ">
                <label htmlFor="description" className="text-h7 font-bold">
                  選択中の資格<span className="red--text">*</span>
                </label>
              </th>
              <td className="form-table__col-data h-[100px] 2xl:h-[120px]  ">
                <div
                  data-testid="selected_certifications"
                  className={`inline-flex ${'items-center'} w-full ${
                    errors?.certificationCodeList?.length > 0 ? 'hidden' : 'h-full'
                  } gap-2 flex-wrap  overflow-y-auto max-h-[100px] `}
                >
                  {selectedIds.length === 0 && errors?.certificationCodeList?.length === 0 && (
                    <span className="text-gray-500  ">未選択</span>
                  )}
                  {selectedIds.map((selectedId, index) => {
                    const node = _.allCertifications[selectedId]
                    const name =
                      node.Metadata.Depth === 3 ? node.CertificationData.Name : node.CertificationData.CategoryName

                    return (
                      <SelectedCertifications
                        name={name}
                        selectedId={selectedId}
                        key={`selectedCertification${index}`}
                      />
                    )
                  })}
                </div>

                {errors?.certificationCodeList?.length > 0 &&
                  errors?.certificationCodeList?.map((e, index) => (
                    <span key={index} className="red--text">
                      {e}
                    </span>
                  ))}
              </td>
            </tr>
            <tr>
              <td className="form-table__col-data" colSpan={2}>
                <div className="flex flex-col items-stretch">
                  <div className="relative mt-3 mb-3 min-w-[300px] w-[40%] ">
                    <i className=" absolute icon-32px right-2 inset-y-0 top-[50%] -translate-y-[50%] flex items-center">
                      <span className="icon-search"></span>
                    </i>
                    <input
                      ref={filterRef}
                      type="text"
                      placeholder="カテゴリーまたは資格名で絞り込み"
                      name="filterCertification"
                      className="text-caption-2 block rounded-lg pl-4 pr-12 pt-2 pb-2.5 w-full !border-0"
                      onChange={(e) => dispatch('filter_certification', e.target.value)}
                    />
                  </div>
                  <div
                    data-testid="certification_selector_tree"
                    className={
                      'border border-solid border-gray-500/50 p-3 mb-3 overflow-auto' +
                      ` max-h-[300px] bg-white h-[170px] 2xl:h-[225px] ${onlyCategoryNone && 'flex'}   `
                    }
                  >
                    {(displayCertificationKeys.length === 0 || onlyCategoryNone) && (
                      <p className="text-center  red--text m-auto ">資格マスターが未登録です</p>
                    )}
                    {showNoResults && (
                      <p className="text-center text-gray-500/70 leading-[20]">
                        該当するカテゴリー/資格は見つかりませんでした
                      </p>
                    )}
                    {!onlyCategoryNone && (
                      <CertificationSelectorTree
                        singleMode={singleMode}
                        id={rootNodeKey}
                        dispatch={dispatch}
                        allCertifications={displayCertifications}
                      />
                    )}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="flex gap-2 max-h-[150px] overflow-auto flex-wrap mt-1 mb-3"></div>

      <div className="modal-content-footer ">
        <div className="footer_button_area gap-x-16">
          <button className="footer-btn button_back" onClick={handleCancel}>
            キャンセル
          </button>
          <SpinnerButton
            name={'設定'}
            className={' footer-btn bg-black px-2 py-2 text-white min-w-[80px] rounded w-[160px]'}
            onClick={handleSave}
          />
        </div>
      </div>
    </div>
  )
}

const CertificationSelectorTree = (props) => {
  const { id, allCertifications, dispatch, singleMode } = props
  const [show, setShow] = React.useState(true)

  const node = allCertifications?.[id]
  if (!node) return <></>

  const { Metadata, CertificationData, SubNode = [] } = node

  const isCertification = Metadata.Depth === 3
  const isRoot = id === rootNodeKey

  const handleNameClick = () => {
    if (!isCertification) return

    dispatch(`select_certification${singleMode ? '_single' : ''}`, node.node)
  }

  let marginLength = (Metadata.Depth - 1) * 50
  if (SubNode.length > 0 && Metadata.Depth > 1) {
    marginLength -= 24
  }
  const name = !isCertification ? CertificationData?.CategoryName : CertificationData?.Name

  return (
    <>
      <CustomTooltip title={name}>
        {(ref) => (
          <div className={`ml-[${marginLength}px] truncate `} ref={ref}>
            {!isRoot && (
              <>
                {SubNode.length > 0 ? (
                  <span
                    role="button"
                    data-testid={`${name}_fold`}
                    className="cursor-pointer"
                    onClick={() => setShow((s) => !s)}
                  >
                    {show ? <ArrowDropDownIcon /> : <ArrowRight />}
                  </span>
                ) : (
                  <span></span>
                )}

                <span
                  role="button"
                  data-testid={`${name}_${Metadata?.Depth || 3}_click`}
                  className={` ${!isCertification ? 'text-black' : 'text-[#3150a5]'}`}
                  onClick={handleNameClick}
                >
                  {name}
                </span>
              </>
            )}
          </div>
        )}
      </CustomTooltip>

      {show &&
        SubNode.map((child) => {
          return (
            <CertificationSelectorTree
              singleMode={singleMode}
              key={`child?${child}`}
              id={child}
              dispatch={dispatch}
              allCertifications={allCertifications}
            />
          )
        })}
    </>
  )
}

export default CertificationSelector
